import { useFeatureFlags } from "@climatepartner/app-shell/feature-flags";
import { Spinner } from "@climatepartner/components/Spinner";
import { PropsWithChildren, ReactElement } from "react";

import { FeatureToggle } from "../feature-flags/feature-toggle";
import { FeatureToggleKey } from "../feature-flags/feature-toggles";
import { MaintenancePage } from "./maintenance-page";

type MaintenanceModeProviderProps = PropsWithChildren<{
  featureToggleKey: FeatureToggleKey;
}>;

const MaintenanceModeProvider = ({ children, featureToggleKey }: MaintenanceModeProviderProps): ReactElement => {
  const { isResolved } = useFeatureFlags();
  // Unresolved flags default to false, which would read as "not in maintenance" and mount the pages
  // mid-maintenance, only to swap them out when the real value arrives. Wait for an answer instead.
  if (!isResolved) {
    return <Spinner />;
  }
  return (
    <>
      <FeatureToggle feature={featureToggleKey}>
        <MaintenancePage />
      </FeatureToggle>
      <FeatureToggle not feature={featureToggleKey}>
        {children}
      </FeatureToggle>
    </>
  );
};

export const CcfMaintenanceModeProvider = ({ children }: PropsWithChildren): ReactElement => {
  return <MaintenanceModeProvider featureToggleKey="maintenanceModeCcf">{children}</MaintenanceModeProvider>;
};

export const PcfMaintenanceModeProvider = ({ children }: PropsWithChildren): ReactElement => {
  return <MaintenanceModeProvider featureToggleKey="maintenanceModePcf">{children}</MaintenanceModeProvider>;
};

export const GlobalMaintenanceModeProvider = ({ children }: PropsWithChildren) => {
  return <MaintenanceModeProvider featureToggleKey="maintenanceMode">{children}</MaintenanceModeProvider>;
};
